import { Inject, Injectable, Optional } from '@angular/core';
import { HttpParamsObject } from '../../services/api/api.service';
import { FhirApiService } from '../../services/api/fhir-api.sevice';
import { UserService } from '../../services/user.service';
import { Organization, OrganizationAdapter } from './organization.model';
import { ProviderSearchParams } from './base-provider.model';
import { BaseProvidersService } from './base-providers.service';
import { ReducerManager, Store } from '@ngrx/store';

@Injectable({ providedIn: 'root' })
export class OrganizationsService extends BaseProvidersService<Organization> {
  constructor(
    @Inject('dataName') @Optional() dataName: string,
    protected adapter: OrganizationAdapter,
    protected fhirApi: FhirApiService,
    protected userService: UserService,
    protected store: Store,
    protected manager: ReducerManager,
  ) {
    super(
      dataName || 'organizations',
      adapter,
      fhirApi,
      userService,
      store,
      manager,
    );
  }

  processProviderSearchParams(params: ProviderSearchParams): HttpParamsObject {
    const paramsObject = {};
    if (params.name) paramsObject['name:contains'] = params.name;
    if (params.zip) paramsObject['address-postalcode'] = params.zip;
    if (params.city) paramsObject['address-city'] = params.city;
    if (params.street || params.house)
      paramsObject['address-line:contains'] = [params.street, params.house]
        .filter((x) => x)
        .join(' ');
    if (params.specialty) paramsObject['specialty'] = params.specialty;
    if (params.parentOrganizationId)
      paramsObject['partof'] = `Organization/${params.parentOrganizationId}`;
    if (params.subjectGroup)
      paramsObject['subject-group'] = params.subjectGroup;
    if (params.facilityType && params.type)
      paramsObject['type'] = [params.type, params.facilityType];
    else if (params.type) 
      paramsObject['type'] = params.type;
    else if (params.facilityType){
      paramsObject['type'] = [params?.facilityType];}
    if (params.active) paramsObject['active'] = params.active;

    if (params.mandantId) paramsObject['partof'] = params.mandantId;

    if (params.ids) {
      paramsObject['_id'] = Array.isArray(params.ids)
        ? params.ids.join(',')
        : params.ids;
    }

    return paramsObject;
  }
}
